// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/pages/SchoolWishListNew/Selected.less
// module id = 967
// module chunks = 0